<template>
  <div class="app-select-small" :class="{'is-outlined': this.outlined}">
    <label class="app-select-label">
      {{label}}
    </label>
    <b-dropdown
      :dropup="dropUp"
      :dropright="dropRight"
      class="select"
      :menu-class="['select-input_list', { centerMenu: centerMenu }]"
      :no-flip="noFlip"
      :toggle-class="['app-select', { 'app-select_full-width': fullWidth }]"
      :block="true"
      :text="currentItem"
      @hidden="closeDropdownHandler"
    >
      <b-dropdown-form class="app-select-small-searchbox" v-if="searchable">
        <search-input
          @search="(search) => searchQuery = search"
          v-model="searchQuery"
          :placeholder="placeholder"
        />
      </b-dropdown-form>
      <!-- <b-dropdown-item
        class="transaction-input__item"
        v-for="(key, index) of keys"
        :key="indexes[index]"
        @click="() => {
          currentItem = key;
          $emit('changeSelect', values[index])
        }"
        :active="currentItem === key"
        :disabled="disabledValues.includes(indexes[index])"
      >
        {{ keys[index] }}
      </b-dropdown-item> -->
      <b-dropdown-group v-if="groups">
        <b-dropdown-group v-for="group in groupedOptions" :key="group.name" :header="group.name"
                          class="app-select-small-group">
          <b-dropdown-item
            class="transaction-input__item"
            v-for="option of group.list"
            :key="option.index"
            @click="() => {
              currentItem = option.key;
              $emit('changeSelect', option.value)
            }"
            :active="currentItem === option.key"
            :disabled="disabledValues.includes(option.index)"
          >
            {{ option.key }}
          </b-dropdown-item>
        </b-dropdown-group>
      </b-dropdown-group>
      <b-dropdown-group v-else>
        <b-dropdown-item
          class="transaction-input__item"
          v-for="option of validOptions"
          :key="option.index"
          @click="() => {
            currentItem = option.key;
            $emit('changeSelect', option.value)
          }"
          :active="currentItem === option.key"
        >
          {{ option.key }}
        </b-dropdown-item>
      </b-dropdown-group>
      <b-dropdown-text
        class="transaction-input__item transaction-input__item-text"
        v-if="searchable && !options.length && searchQuery">
        {{ $t('CP.selectSearchNotFound') }}
      </b-dropdown-text>
    </b-dropdown>
  </div>
</template>

<script>
import SearchInput from '../../components/SearchInput/SearchInput';

export default {
  name: 'AppSelectSmall',
  components: {
    SearchInput,
  },
  emits: ['changeSelect'],
  props: {
    keys: {
      type: Array,
      default: () => [],
    },
    values: {
      type: Array,
      default: () => [],
    },
    indexes: {
      type: Array,
      default: () => [],
    },
    disabledValues: {
      type: Array,
      default: () => [],
    },
    default: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    noFlip: {
      type: Boolean,
      default: true,
    },
    dropUp: {
      type: Boolean,
      default: false,
    },
    dropRight: {
      type: Boolean,
      default: false,
    },
    centerMenu: {
      type: Boolean,
      default: false,
    },
    fullWidth: {
      type: Boolean,
      default: false,
    },
    searchable: {
      type: Boolean,
    },
    groups: {
      type: Array,
    },
    outlined: {
      type: Boolean,
    },
    placeholder: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      currentItem: '',
      searchQuery: '',
    };
  },
  computed: {
    options() {
      let options = this.keys?.map((key, index) => (
        {
          key,
          value: this.values?.[index],
          index: this.indexes?.[index],
        }
      ));
      if (this.currentItem) {
        const currentOption = options.find((item) => item.key === this.currentItem);
        options.splice(options.indexOf(currentOption), 1);
        options.unshift(currentOption);
      }
      if (this.searchQuery) {
        const searchQuery = this.searchQuery.toLowerCase();
        options = options.filter((item) => {
          const itemKey = item.key.toLowerCase();
          return itemKey.indexOf(searchQuery) !== -1;
        });
      }
      return options;
    },
    validOptions() {
      let options = [...this.options];
      options = options.filter((option) => !this.disabledValues.includes(option?.index));
      if (this.currentItem) {
        const currentOption = this.options.find((item) => item.key === this.currentItem);
        options.unshift(currentOption);
      }
      return [...new Set(options)];
    },
    groupedOptions() {
      const groups = this.groups.map((group) => ({
        name: group.name,
        list: [],
      }));
      this.options.forEach((option) => {
        this.groups.forEach((group) => {
          if (group.list.includes(option.key)) {
            const currentGroup = groups.find((item) => item.name === group.name);
            if (currentGroup) {
              currentGroup.list.push(option);
            }
          }
        });
      });
      return groups.filter((group) => group.list.length);
    },
  },
  methods: {
    closeDropdownHandler() {
      this.searchQuery = '';
      this.$el.querySelector('.dropdown-menu').scrollTop = 0;
    },
  },
  mounted() {
    this.currentItem = this.default;
  },
};
</script>

<style scoped lang="scss">
.app-select-small {
  text-align: left;

  &.is-outlined {
    display: flex;
    flex-direction: column;
  }
}
::v-deep {

  .app-select,
  .app-select:focus,
  .app-select:hover,
  .app-select.focus,
  .app-select:active {
    .app-select-small:not(.is-outlined) & {
      flex: 0 1 192px;
      //max-width: 186px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      text-align: left;
      border: none!important;
      border-bottom: 1px solid rgba(72, 82, 140, 0.15) !important;
      border-radius: 0;
      height: 25px;
      padding: 0 20px 0 0;
      font-size: 16px;

      &::after {
        position: absolute;
        right: 0;
      }
    }

    color: var(--btn-primary) !important;
    border-color: var(--gray-lighten);
    background: #FFFFFF !important;
    font-size: 14px;
    height: 45px;
    outline: none!important;
    box-shadow: none!important;
  }
  .app-select_full-width,
  .app-select_full-width:focus,
  .app-select_full-width:hover,
  .app-select_full-width.focus,
  .app-select_full-width:active {
    max-width: 100%;
  }

  .select-input_list {
    padding: 0;
    box-shadow: 0 2px 6px rgba(0, 76, 165, 0.4);
    border-radius: 3px;
    border: none;
    max-height: 200px;
    overflow-y: auto;
    min-width: 100%;
  }

  .app-select-label {
    font-size: 13px;
    opacity: 0.4;
    margin: 0;

    .app-select-small.is-outlined & {
      display: block;
      margin-top: 10px;
      font-weight: 500;
      margin-bottom: 10px;
      line-height: 1;
      font-size: .875rem;
      opacity: 1;
    }
  }
  .app-select-small-searchbox .b-dropdown-form {
    padding: 10px 15px 0;
  }
  .app-select-small .dropdown-header {
    padding: 0 15px;
  }
  .app-select-small-group {
    padding: 15px 0;
  }
  .app-select-small-group:not(:last-child) {
    border-bottom: 1px solid #e9ecef;
  }
}
</style>
